<template>
  <div id="app" :class="classNames">
    <InfoBanner />
    <navbar />
    <div class="wrapper">
      <section
        class="section main-scroll-content"
        :class="{ 'is-covered': settings.isSidebarExpanded }"
      >
        <div class="container-fluid" ref="container">
          <keep-alive include="audience-board">
            <router-view />
          </keep-alive>
          <resize-observer @notify="onResize" />
        </div>
      </section>
    </div>
    <progress-bar />
    <div id="notifications">
      <notification v-for="item in notifications" :item="item" :key="item.id" />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { ResizeObserver } from 'vue-resize';
import Navbar from './views/site/nav/Navbar';


import { loadConfig } from './config';

// This component is a presentation component for showing platform outage.
// This is not used in the template as of now.
// But to be used when there is an outage in the platform
// that should be notified to clients
import ErrorBanner from './components/banners/OngoingTrouble';
import router from './router';

import settings from 'store/busses/SettingsBus';
import notifications from 'services/Notifications';
import Api from 'services/Api';

import ProgressBar from 'views/elements/ProgressBar';
import Notification from 'views/site/Notification';
import InfoBanner from './components/banners/IctNavigation';
import { className } from 'postcss-selector-parser';

export default {
  name: 'App',

  components: {
    Notification,
    Navbar,
    ResizeObserver,
    ProgressBar,
    InfoBanner,
  },

  data() {
    return {
      settings,
    };
  },

  computed: {
    notifications() {
      return notifications.items;
    },

    isAppRoute() {
      return this.$route.path.startsWith('/apps/');
    },

    routeName() {
      return this.$route.name ? `page-${this.$route.name}` : '';
    },

    classNames() {
      return [
        this.routeName,
        window.hideNavbar ? 'hide-navbar' : 'has-navbar-fixed-top',
      ];
    },
  },

  methods: {
    onResize: debounce(function () {
      this.settings.width = this.$refs.container.getBoundingClientRect().width;
    }, 150),
  },
};
</script>

<style lang="scss">
@import '../node_modules/vue-resize/dist/vue-resize.css';
@import '~scss/main';

$FontPathOpenSans: '../node_modules/npm-font-open-sans/fonts';
@import '../node_modules/npm-font-open-sans/open-sans';

$mdi-font-path: '../node_modules/@mdi/font/fonts';
@import '../node_modules/@mdi/font/scss/materialdesignicons.scss';

#notifications {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px;
  z-index: 9999;
  pointer-events: none;
}

.wrapper {
  display: flex;
  height: calc(100vh - 64px);
  background-color: $white-bis;
  position: relative;
}

.section {
  flex: 1;
  overflow-x: hidden;

  .has-sidebar & {
    margin-left: 62px;
  }

  &.is-covered {
    outline: 5px solid black;
    // filter: blur(1px);
  }
}

.container-fluid {
  position: relative;
  max-width: $fullhd;
  margin: 0 auto;
}

.page-audience,
.page-audience-user,
.page-audience-trip,
.page-webhooks,
.page-activities,
.page-api_keys {
  .section {
    padding: 0;
  }

  .container-fluid {
    max-width: none;
  }
}

.page-audience-list .wrapper {
  background-color: white;
}

.hide-navbar nav.navbar {
  display: none;
}
</style>
